import { holidaysApi } from "./holidays.api";

export const { useGetHolidaysByCompanyQuery, useSaveHolidaysByCompanyMutation, useDeleteHolidaysByCompanyMutation } = holidaysApi;
